@if(isLoading){
<div class="loading-bar"></div>
}
